var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C12.7614 0 15 2.23858 15 5C15 6.95672 14.8947 8.05085 14.4167 9.22009C14.2456 9.63874 14.0333 10.0158 13.7797 10.3476L15.1089 10.8464C17.4496 11.7252 19 13.9634 19 16.4636V18C19 18.5523 18.5523 19 18 19H2C1.44772 19 1 18.5523 1 18V16.4664C1 13.9645 2.55245 11.7252 4.89537 10.8476L6.2225 10.3506C5.96794 10.018 5.75488 9.63997 5.58325 9.22009C5.10532 8.05085 5 6.95672 5 5C5 2.23858 7.23858 0 10 0ZM10 12.0266C9.32754 12.0266 8.72383 11.9322 8.18871 11.7512L5.59691 12.7205C4.03496 13.3056 3 14.7985 3 16.4664V17H17V16.4636C17 14.7968 15.9664 13.3047 14.4059 12.7188L11.8183 11.7488C11.2814 11.9314 10.6754 12.0266 10 12.0266ZM10 2C8.34315 2 7 3.34315 7 5C7 8.58575 7.58895 10.0266 10 10.0266C12.411 10.0266 13 8.58575 13 5C13 3.34315 11.6569 2 10 2Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.3c1394ab7f4efc30098e50d08970912e.svg";
export { ForwardRef as ReactComponent };